<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>子庫調用</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



      <div class="content">

        <div class="c-row">
          <el-button class="el-button">新建</el-button>
        </div>

        <div>
          <template>
                <div style="min-height:500px;">
                  <el-table
                  v-loading="pictLoading"
                  element-loading-text="數據正在加載中"
                  element-loading-spinner="el-icon-loading"
                  ref="multipleTable"
                  :data="tableData"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"
                  tooltip-effect="dark"
                  style="margin-left:50px; width: 1100px;">
                  <el-table-column
                    type="index"
                    label="序號"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="proj_title"
                    label="項目名稱"
                    width="220">
                  </el-table-column>
                  <el-table-column
                    prop="proj_detail"
                    label="項目簡介"
                    width="350">
                  </el-table-column>
                  <el-table-column
                    prop="proj_result"
                    label="項目成果"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="proj_datetime"
                    label="發布時間"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="100">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="readsub(scope.$index, scope.row.ID)">查看</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                </div>
                

                <div style="width:1150px; margin-bottom:10px;">
                  <div style="text-align: right;margin-top: 30px;">
                  <el-pagination
                    background
                    :current-page="currentpage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pagesize"
                    :data="tableData"
                    :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor"
                    layout="total,sizes,prev, pager, next"
                    :total="totalcount"
                    @current-change="current_change"
                    @size-change="size_change">
                  </el-pagination>
                </div>

                </div>

                


              </template>
        </div>

      </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      tableData:[],
      totaldata:'99999',
      currrentpage:1,
      pageSize:20,
      totalcount:100,
      uid:0,
    };
  },
  methods: {

    current_change(val){
      this.currrentpage=val;
      this.submitform();
      //this.retrieval();
    },
    size_change(val){
      this.pageSize=val;
      this.submitform();
    },
    submitform(){
      //alert('sunbmitform');

      this.uid=window.sessionStorage.getItem('hguid');
      this.$http
      .get(`${this.$store.state.baseurl}/api/hgsub/getsublist?cpage=`+this.currrentpage+'&psize='+this.pageSize+'&uid='+this.uid)
      .then((res) => {
        let json=JSON.parse(res.data);
        //this.currentpage=
        this.tableData=json.data;
        this.totalcount=json.dataSize;
      });



    },

    //
    readsub(a,b){
      //window.alert(b);
      this.$router.push({ path: "/hgsub_detail",query:{id:b}});

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
    //设置表格行的样式
   tableRowStyle({row,rowIndex}){
     let st;
     if(rowIndex%2==1){
       st={
         'background-color':'#f0f0f0',
       };

     }
     return st;
     },
      //设置表头行的样式
     tableHeaderColor({row,column,rowIndex,columnIndex}){
        return 'background-color:#d4c9bc;color:#9a7455;font-wight:500;font-size:16px;text-align:center;height: 50px';
      },
  },
  created() {
    this.uid=window.sessionStorage.getItem('hguid');
      this.$http
      .get(`${this.$store.state.baseurl}/api/hgsub/getsublist?cpage=`+this.currrentpage+'&psize='+this.pageSize+'&uid='+this.uid)
      .then((res) => {
        let json=JSON.parse(res.data);
        this.tableData=json.data;
        this.totalcount=json.dataSize;
      });
  },
};
</script>


<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .c-row{
    width:1100px;
    margin-left: auto;
    margin-right: auto;
    .el-button{
      color: #ffffff;
      width: 90px;
      height: 40px;
      float: right;
      margin: 20px;
      border-radius: 5px;
      background-color: #c60828;

    }
  }
  
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.my-table{
  margin-left: auto;
  margin-right: auto;
  .my-tbody{
    display: table-row-group;
    vertical-align: middle;
    width: 1100px;
    
    tr {
        display: table-row;
        vertical-align: inherit;
        th {
          display: table-cell;
          vertical-align: inherit;
          font-weight: bold;
          text-align: left;
          height: 50px;
          border: none;
          background-color: #d4c9bc;
      }
        td {
          display: table-cell;
          vertical-align: inherit;
          text-align: left;
          height:80px;
      }
    }

  }
}

.c1{
  width: 100px;
}
.c2{
  width: 200px;
}
.c3{
  width: 300px;
}
.c4{
  width: 300px;
}
.c5{
  width: 100px;
}
.c6{
  width: 100px;
}





</style>